module.exports = __webpack_public_path__ + "img/11-IP-boost-your-confidence-before-the-interview.584d2108.svg";